import { SOCKET_URL } from "./common/constants";

class SocketService {
socket: WebSocket;
isConnected : boolean;
topic : string | null;

  constructor() {
    this.socket = null as never as WebSocket;
    this.isConnected = false;
    this.topic = null;
  }

  subscribe(topic: string, onMessageCallback: Function, onErrorCallback: Function) {
    if (this.socket) {
      this.disconnect();
    }
    
    this.topic = topic;
    console.log("WebSocket URL:", SOCKET_URL);

    this.socket = new WebSocket(SOCKET_URL);

    this.socket.onopen = () => {
      this.isConnected = true;

      const joinMsg = {
        type: "join",
        topicId: topic,
      };
      this.socket.send(JSON.stringify(joinMsg));
    };

    this.socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (onMessageCallback) {
          onMessageCallback(data);
        }
      } catch (e) {
        console.error("Failed to parse socket message", e);
      }
    };

    this.socket.onerror = (error) => {
      console.error("WebSocket error:", error);
      if (onErrorCallback) {
        onErrorCallback(error);
      }
    };

    this.socket.onclose = () => {
      console.log("WebSocket connection closed");
      this.isConnected = false;
      this.socket = null as never as WebSocket;
    };
  }

  sendMessage(topicId: string, body: any) {
    if (!this.socket || !this.isConnected) {
      console.warn("WebSocket not connected");
      return;
    }

    const msg = {
      type: "chat",
      topicId,
      body,
    };

    this.socket.send(JSON.stringify(msg));
  }

  disconnect() {
    if (this.socket) {
      try {
        if (this.topic) {
          this.socket.send(
            JSON.stringify({ type: "leave", topicId: this.topic })
          );
        }
      } catch (e) {
      }

      this.socket.close();
    }

    this.socket = null as never as WebSocket;
    this.isConnected = false;
    this.topic = null;
  }
}

const socketService = new SocketService();

export default socketService;